import { apiClient, ensureCsrfCookie } from '../../api/client';

/**
 * Вход в мобильный стол из Telegram Web App по initData (Блок 2b §6).
 *
 * Бот открывает /learning?twa=1 как web_app. SDK telegram-web-app.js (подключён в
 * index.html) кладёт подписанный initData в window.Telegram.WebApp. Шлём его на
 * публичный stateful-эндпоинт /api/knowledge-bot/webapp-auth — бэкенд проверяет HMAC
 * и ставит SPA-сессию под нужным пользователем (passwordless, без повторного логина).
 */
const API_BASE_URL =
  (import.meta.env.VITE_API_URL as string | undefined) || 'https://api.opsmind.ru/api/v1';
// База бота — тот же хост, префикс /api/knowledge-bot (как ADMIN_BASE в learning/api.ts).
const KB_BASE = API_BASE_URL.replace(/\/api\/v1\/?$/, '/api/knowledge-bot');

interface TelegramWebApp {
  initData?: string;
  ready?: () => void;
  expand?: () => void;
}

export function getTelegramWebApp(): TelegramWebApp | null {
  const tg = (window as unknown as { Telegram?: { WebApp?: TelegramWebApp } }).Telegram?.WebApp;
  return tg ?? null;
}

/** Подписанный initData, если страница открыта внутри Telegram Web App. */
export function getTelegramInitData(): string | null {
  const initData = getTelegramWebApp()?.initData;
  return typeof initData === 'string' && initData.length > 0 ? initData : null;
}

/** Сигнал Telegram, что webview готов + развернуть на полный экран. Идемпотентно. */
export function initTelegramWebApp(): void {
  const tg = getTelegramWebApp();
  tg?.ready?.();
  tg?.expand?.();
}

/** Активен ли twa-режим (липкий флаг — как useTwaMode в AppShell). */
export function isTwaMode(search: string): boolean {
  if (new URLSearchParams(search).get('twa') === '1') {
    return true;
  }
  try {
    return sessionStorage.getItem('opsmind_twa') === '1';
  } catch {
    return false;
  }
}

export async function webAppAuth(initData: string): Promise<{ id: number; name: string }> {
  await ensureCsrfCookie();
  const { data } = await apiClient.post(
    '/webapp-auth',
    { init_data: initData },
    { baseURL: KB_BASE },
  );
  return data.data as { id: number; name: string };
}
